export default "<div #template [innerHtml]=\"_contentHtml\" class=\"dynamic-integration p-3\"></div>\n";